import { Injectable } from '@angular/core';
import { jwtDecode, JwtPayload } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class JwtDecodeService {

  constructor() { }

  /**
   * Decodes a JWT token and returns its payload.
   * @param token The JWT string.
   * @returns Decoded payload or null if invalid.
   */
  decodeToken<T extends object = JwtPayload>(token: string): T | null {
    try {
      if (!token || typeof token !== 'string') {
        throw new Error('Invalid token format');
      }
      return jwtDecode<T>(token);
    } catch (error) {
      console.error('JWT decoding failed:', error);
      return null;
    }
  }

  /**
   * Checks if the token is expired.
   * @param token The JWT string.
   * @returns true if expired, false otherwise.
   */
  isTokenExpired(token: string): boolean {
    const decoded = this.decodeToken(token);
    if (!decoded || !('exp' in decoded)) {
      return true; // Treat as expired if no exp field
    }
    const expiryTime = (decoded as JwtPayload).exp!;
    return Date.now() >= expiryTime * 1000;
  }
}
